<div class="h-full flex flex-col overflow-visible">
  @if (!initialState() || isTransitioning()) {
  <div @headerEnter
    class="shrink-0 flex flex-row gap-x-4 items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 overflow-visible">
    <!-- icon -->
    <div class="size-6 shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="size-6 text-primary">
        <path
          d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
        <path d="M20 2v4" />
        <path d="M22 4h-4" />
        <circle cx="4" cy="20" r="2" />
      </svg>
    </div>
    <!-- icon END -->

    <!-- Search input -->
    <textarea id="ai-search-query-compact" name="ai-search-query-compact" rows="1" class="flex-1 block w-full input-primary text-primary"
      [value]="inputValue()" (input)="inputValue.set($any($event.target).value)"
      (keydown)="onSearchKeydown($event)"
      placeholder="Search for anything..."></textarea>
    <!-- Search input END -->

    <!-- RHS -->
    <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">
      <!-- Search Btn -->
      @if (isLoading()) {
      <button class="inline-flex items-center flashy-go-button">
        ...
        <svg aria-hidden="true" class="mx-auto w-6 h-6 text-gray-200 animate-spin dark:text-gray-500 fill-primary"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill" />
        </svg>
      </button>
      } @else {
      <button (click)="search()" type="button" [disabled]="searchDisabled()"
        class="inline-flex items-center flashy-go-button">
        Search
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21 21-4.34-4.34" />
          <circle cx="11" cy="11" r="8" />
        </svg>
      </button>
      }
      <!-- Search Btn END -->

      <!-- Collaborate Btn -->
      <div class="relative overflow-visible">
        <button type="button" (click)="collaboratorsService.showCollaborators.set(true)" class="fab-button-primary">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-6">
            <path d="M16 5H3" />
            <path d="M11 12H3" />
            <path d="M16 19H3" />
            <path d="M18 9v6" />
            <path d="M21 12h-6" />
          </svg>
        </button>
        @if (collaboratorsService.selectedCreators().length > 0) {
        <span
          class="z-10 absolute -top-3 -right-3 inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-sm font-medium text-accent ring-1 ring-inset ring-primary/15">
          {{ collaboratorsService.selectedCreators().length }}</span>
        }
      </div>
      <!-- Collaborate Btn  END-->
    </div>
    <!-- RHS END -->
  </div>

  }


  <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
    @if (initialState()) {
    <div class="search-initial-wrapper h-full w-full flex flex-col items-center justify-center px-4 py-6 sm:py-10">
      <div class="search-block-animate w-full max-w-3xl mx-auto"
        [@searchBlockLeave]="isTransitioning() ? 'leaving' : 'visible'"
        (@searchBlockLeave.done)="onSearchBlockLeaveDone()">

        <div class="text-center mb-8">
          <div
            class="mx-auto flex items-center justify-center size-16 rounded-2xl bg-gradient-to-br from-primary/15 to-brand-studio/15 ring-1 ring-primary/10 dark:ring-primary/20 mb-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="size-8 text-accent">
              <circle cx="10" cy="7" r="4" />
              <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
              <circle cx="17" cy="17" r="3" />
              <path d="m21 21-1.9-1.9" />
            </svg>
          </div>

          <h3 class="text-2xl sm:text-3xl font-semibold tracking-tight">
            <span class="ai-search-heading-gradient">Find your perfect creator</span>
          </h3>
          <p class="mt-3 text-sm sm:text-base text-secondary mx-auto leading-relaxed text-center sm:whitespace-nowrap">
            Describe what you're looking for in plain English and our AI will find matching creators.
          </p>
        </div>

        <div class="search-input-container flex flex-col gap-y-4">
          <div class="flex flex-row items-start gap-3">
            <div
              class="shrink-0 flex size-9 items-center justify-center rounded-lg bg-primary/10 dark:bg-primary/15 text-accent">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-4">
                <path
                  d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                <path d="M20 2v4" />
                <path d="M22 4h-4" />
                <circle cx="4" cy="20" r="2" />
              </svg>
            </div>

            <!-- <textarea id="ai-search-query" name="ai-search-query" rows="3" [value]="inputValue()"
              (input)="inputValue.set($any($event.target).value)"
              (keydown)="onSearchKeydown($event)"
              class="flex-1 block w-full resize-none bg-transparent text-base text-primary placeholder:text-muted-foreground focus:outline-none leading-relaxed"
              placeholder="e.g. Fitness creators in London with 50k+ followers who post workout content"></textarea> -->
            
            <textarea id="ai-search-query" name="ai-search-query" rows="3" [value]="inputValue()"
              (input)="inputValue.set($any($event.target).value)"
              (keydown)="onSearchKeydown($event)"
              class="flex-1 block w-full resize-none input-textarea-transparent text-primary"
              placeholder="e.g. Fitness creators in London with 50k+ followers who post workout content"></textarea>
          </div>

          <div class="flex flex-row items-center justify-between gap-3 border-t border-border pt-4">
            @if (isLoading()) {
            <button type="button" class="inline-flex items-center flashy-go-button ml-auto" disabled>
              <svg aria-hidden="true" class="size-5 text-white/80 animate-spin"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
            </button>
            } @else {
            <button (click)="search()" type="button" [disabled]="searchDisabled()"
              class="inline-flex items-center flashy-go-button ml-auto">
              Search
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
              </svg>
            </button>
            }
          </div>
        </div>

        @if (!showFilters()) {
        <div class="mt-6">
          <p class="text-xs font-medium text-secondary text-center mb-3">Try an example</p>
          <div class="flex flex-wrap items-center justify-center gap-2">
            @for (example of searchExamples; track $index) {
            <button type="button" (click)="quickSearch(example)"
              class="inline-flex items-center rounded-full px-3 py-1.5 text-xs font-medium bg-primary/10 text-accent ring-1 ring-inset ring-primary/15 hover:bg-primary/15 transition-colors cursor-pointer">{{
              example }}</button>
            }
          </div>
        </div>
        }

        @if (showFilters()) {
        <div
          class="mt-6 rounded-md p-4 bg-amber-50 text-amber-800 ring-1 ring-inset ring-amber-200 dark:bg-amber-400/10 dark:text-amber-300 dark:ring-amber-400/30">
          <div class="flex">
            <div class="shrink-0">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="size-5 text-amber-500 dark:text-amber-300">
                <path
                  d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium">Attention needed</h3>
              <div class="mt-2 text-sm text-amber-700/90 dark:text-amber-200/85">
                <p>Filters are not available yet. They'll be coming soon.</p>
              </div>
            </div>
          </div>
        </div>
        }

      </div>
    </div>
    }

    @if (isLoading()) {
    <div class="w-full h-full overflow-hidden min-h-0 scrollbar-hide text-primary flex flex-col items-center justify-center">
      <div class="text-center">
        <div class="mx-auto size-36">
          <om-orb>
            <div class="content"></div>
          </om-orb>
        </div>

        <h3 class="mt-2 text-md font-semibold text-primary">Searching...</h3>
        <om-typewriter class="mx-auto max-w-md"
          [words]="['Searching for creators...', 'By location...', 'Checking their content...', 'Sorting creators...', 'Filtering direct matches...', 'Summarising...']"
          [writeDelay]="100" [writeSpeed]="30" styleClass="typewriter-large"></om-typewriter>
      </div>
    </div>
    }


    @if (!isLoading() && !errorMessage() && (searchMeta()?.total ?? 0) > 0) {
    <div class="h-full w-full flex flex-col space-y-4 overflow-y-auto scrollbar-transparent pt-4">
      @for (item of allResults(); track $index) {
      <gsv4-gold-search-item [creatorResult]="item"></gsv4-gold-search-item>
      }
    </div>
    }
  </div>


  @if (!initialState() && (searchMeta()?.total ?? 0) > 0) {
  <div class="shrink-0 flex flex-row items-center justify-between w-full border-t border-border pt-2 overflow-visible">
    <div class="hidden sm:block">
      <p class="text-sm text-secondary">
        Showing <span class="font-medium">{{ allResults().length }}</span> of
        <span class="font-medium">{{ searchMeta()!.total }}</span> results
        in {{ searchMeta()!.searchDurationMs / 1000 | number:'1.2-2' }}s
      </p>
    </div>
    <div class="flex flex-1 items-center justify-end gap-3 sm:flex-none">
      @if (isPaginating()) {
      <div class="flex items-center gap-2 px-3 py-2">
        <div class="flex gap-1">
          <span class="size-1.5 rounded-full bg-[--primary] animate-bounce [animation-delay:0ms]"></span>
          <span class="size-1.5 rounded-full bg-[--primary] animate-bounce [animation-delay:150ms]"></span>
          <span class="size-1.5 rounded-full bg-[--primary] animate-bounce [animation-delay:300ms]"></span>
        </div>
        <span class="text-sm text-secondary">Loading…</span>
      </div>
      } @else if (hasMore) {
      <button type="button" (click)="loadMore()"
        class="relative inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-semibold bg-card text-primary border border-border hover:bg-muted transition-colors cursor-pointer">
        Next
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
          <path fill-rule="evenodd"
            d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z"
            clip-rule="evenodd" />
        </svg>
      </button>
      } @else {
      <span class="text-sm text-secondary px-3 py-2">All results loaded</span>
      }
    </div>
  </div>
  }

</div>

@if (collaboratorsService.showCollaborators()) {
<cc-collaborators></cc-collaborators>
}
@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}
@if (socialScreeningService.showToBeScreeneed()) {
<sb-creators-for-list></sb-creators-for-list>
}


@if (magicSearchService.previewVideo()) {
<atom-single-video-viewer-summary class="z-999" [video]="magicSearchService.previewVideo()!"
  (closePreviewOut)="magicSearchService.previewVideo.set(undefined)"></atom-single-video-viewer-summary>
}